import { createSlice } from '@reduxjs/toolkit';

export interface CookieConsentState {
  isAccepted: boolean;
}

const initialState: CookieConsentState = {
  isAccepted: false,
};

export const cookieConsentSlice = createSlice({
  name: 'cookieConsent',
  initialState: initialState,
  reducers: {
    acceptConsent: (state: CookieConsentState): void => {
      state.isAccepted = true;
    },
  },
});

export const { acceptConsent } = cookieConsentSlice.actions;

export const getCookieConsentAccepted = (state: { cookieConsent: CookieConsentState }): boolean => {
  return state.cookieConsent.isAccepted;
};

export default cookieConsentSlice.reducer;
